import Vue from 'vue';
import { socketStream } from '../../model/socket-stream.js';

export default {
	namespaced: true,
	state: {
		summary: {}
	},
	mutations: {
		replaceSummary(state, data) {
			Vue.set(state, 'summary', data);
		}
	},
	getters: {
		getSummary(state) {
			return state.summary;
		}
	},
	actions: {
		initialize(state) {
			let subMsg = JSON.stringify({
				ClassName: "ClosedPositionsSummarySubscription"
			});
			socketStream.addChannelHandler('ClosedSummary', 'closedSummary', (data) => {
                let sum = parseSummary(data);
				if (sum)
					state.commit('replaceSummary', sum);
			})
			socketStream.subscribeOnConnect(() => {
				socketStream.socket.send(subMsg);
			});
		}
	}
}

function parseSummary(summaryObj) {
    //console.log(JSON.stringify(summaryObj));
    let acc = '949'
	return summaryObj[acc];
	// {"AccountId":949, "SumBySymbol": {"AUDUSD": 
	//      {"Count":14,"CountProfit":14,"ProfitAbs":88284.98,"ProfitPoints":1813.78}, ...
}